import { MerchantAccountStatusOutput } from '@allocab/allocab-driver-shared-types';
import { useMutation } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient } from '../services/datastore/react-query';
import { driverApi } from '../services/network/Api';

const createMerchantAccount = () =>
  driverApi.post<undefined, MerchantAccountStatusOutput>('/v1/merchant/account/create');

export const useCreateMerchantAccount = () =>
  useMutation({
    mutationFn: createMerchantAccount,
    onSuccess: merchantAccount => {
      queryClient.setQueryData(queryKeys.user.fetchMerchantAccountStatus(), merchantAccount);
    },
  });
